@if (visible()) {
    <p-dialog
        [visible]="displayMatchingProfilesDialog()"
        header="Matching Profiles"
        [modal]="true"
        [closable]="false"
        [resizable]="false"
        [style]="{ 'max-width': '600px', width: '100%' }"
        appedTo="body">
        <input type="hidden" />
        @for (profile of prompts(); track $index) {
            <p-panel styleClass="my-2">
                <div class="flex flex-wrap align-items-center">
                    <div class="flex-1">{{ profile.miProNumber }} - {{ profile.title }} {{ profile.firstName }} {{ profile.lastName }}</div>

                    <div class="flex align-items-center">
                        <button
                            pButton
                            pRipple
                            type="button"
                            label="Merge"
                            class="m-button-primary mr-2 p-button-sm"
                            (click)="onProfileSelected(profile.id)">
                            <i class="material-icons">merge_type</i>
                        </button>

                        <p-button icon="pi pi-trash" severity="danger" size="small" (onClick)="deleteMatchingProfile(profile.id)" />
                    </div>
                </div>
            </p-panel>
        }

        <div class="flex align-items-center">
            <p class="m-0">Click on the <b>Merge</b> button to merge the selected profile and yours into one.</p>

            <p-button icon="pi pi-info-circle" [rounded]="true" [text]="true" (onClick)="mergeHelp.toggle($event)" />
            <p-overlayPanel #mergeHelp styleClass="w-full" [style]="{ 'max-width': '600px' }">
                <p>These Patient profiles match your Surname and Date of Birth.</p>
                <p class="text-sm"><b>Note</b>: Once you start the merging process you will be automatically logged out.</p>
            </p-overlayPanel>
        </div>

        <ng-template pTemplate="footer">
            <button
                type="button"
                pButton
                icon="pi pi-times"
                label="I'll Review Later"
                class="p-button-outlined"
                [loading]="markingPrompts()"
                (click)="reviewLater()"></button>
        </ng-template>
    </p-dialog>

    <merge-patient-dialog
        [(visible)]="displayMergePatientDialog"
        [parentId]="sourcePatientId"
        [childId]="targetPatientId()"
        [authToken]="authToken()"
        (onHide)="mergeDialogClosed()">
    </merge-patient-dialog>
}
